// extracted by css-extract-rspack-plugin
export default {"root":"mFVzc","slot":"Flv6K","fallback":"u22we"};